import { MultiToggle, Option } from "PFComponents/multi_toggle";
import { NotificationFrequency, NotificationSetting } from "PFTypes";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

type NotificationSettingFrequencyCellProps = {
  notificationSetting: NotificationSetting;
};

export const NotificationSettingFrequencyCell = ({
  notificationSetting
}: NotificationSettingFrequencyCellProps) => {
  const { t } = useTranslation("notificationsSettings");
  const { control } = useFormContext();

  const options: Option<NotificationFrequency>[] = notificationSetting.frequencyOptions.map((frequency) => ({
    id: frequency,
    value: t(`frequency.${frequency}`)
  }));

  return (
    <Controller
      control={control}
      name={`${notificationSetting.id}.frequency`}
      render={({ field: { onChange, value } }) => (
        <MultiToggle controlledValue={value} options={options} onChange={onChange} />
      )}
    />
  );
};
